import { initializeApp } from 'firebase/app';
import { getAuth, RecaptchaVerifier } from 'firebase/auth';

const firebaseConfig = {
    apiKey: 'AIzaSyD7Y7QFu1yPEOrG5sE7-gO7TpdcW1ihZl4',
    authDomain: 'snatch-prod.firebaseapp.com',
    projectId: 'snatch-prod',
    storageBucket: 'snatch-prod.appspot.com',
    messagingSenderId: '692067952833',
    appId: '1:692067952833:web:01eea71ec225e7975fcc40',
    measurementId: 'G-EXB1X735RC',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

auth.languageCode = 'en';

try {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.recaptchaVerifier = new RecaptchaVerifier('captcha-container', { size: 'invisible' }, auth);
} catch (e) {
    console.log('error recaptcha', e);
}

export default app;
